import { render } from "./LandownerEstates.vue?vue&type=template&id=93fcc1c2&scoped=true&ts=true&lang=pug"
import script from "./LandownerEstates.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandownerEstates.vue?vue&type=script&lang=ts&setup=true"

import "./LandownerEstates.vue?vue&type=style&index=0&id=93fcc1c2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93fcc1c2"]])

export default __exports__